/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Empty_AllInputs */

const en_notifications_empty_all = /** @type {(inputs: Notifications_Empty_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No notifications yet.`)
};

const pt_br2_notifications_empty_all = /** @type {(inputs: Notifications_Empty_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma notificação ainda.`)
};

/**
* | output |
* | --- |
* | "No notifications yet." |
*
* @param {Notifications_Empty_AllInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_empty_all = /** @type {((inputs?: Notifications_Empty_AllInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Empty_AllInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_empty_all(inputs)
	return pt_br2_notifications_empty_all(inputs)
});